<template>
  <div>
    <modal name="signature">
      <md-card>
        <md-card-header>وارد کردن امضا</md-card-header>
        <md-card-content>
          <md-field>
            <label for="signature">امضای خود را وارد کنید</label>
            <md-textarea required v-model="signature"></md-textarea>
          </md-field>
        </md-card-content>
        <md-card-actions>
          <md-button class="md-primary md-raised" @click="()=>{signedTransaction = true;Vote(_kuknos_proposal_type,_kuknos_proposal_id,_kuknos_proposal_vote)}">ثبت</md-button>
        </md-card-actions>
      </md-card>
    </modal>
    <md-dialog :md-active.sync="showInfo">
      <md-card>
        <md-card-header class="text-center">جزئیات پیشنهاد</md-card-header>
        
          <md-card-content v-if="info.newProposal != undefined">
            <md-field>
              <label for="">عنوان میزبان</label>
              <md-input readOnly :value="info.newProposal" style="text-align:center"></md-input>
            </md-field>
            <md-field>
              <label for="">هش فایل پیشنهاد</label>
              <md-input :value="info.fileHash" style="text-align:center"></md-input>
            </md-field>
            <md-list >
              <md-subheader>لیست نمایندگان</md-subheader>

              <md-list-item v-for="member in info.newMembers"> {{member}} </md-list-item>
            </md-list>
          </md-card-content>
          <md-card-content v-if="info.updateAnchorProposals != undefined">
            <md-field>
              <label for="">عنوان میزبان</label>
              <md-input :value="info.updateAnchorProposals.name" style="text-align:center"></md-input>
            </md-field>
            <md-field>
              <label for="">هش فایل پیشنهاد</label>
              <md-input :value="info.fileHash" style="text-align:center"></md-input>
            </md-field>
            <md-list >
              <md-subheader>لیست نمایندگان</md-subheader>

              <md-list-item v-for="member in info.updatedMembers"> {{member}} </md-list-item>
            </md-list>
          </md-card-content>
          <md-card-content v-if="info.removeAnchorProposal != undefined">
            <md-field>
              <label for="">میزبان حذف شونده</label>
              <md-input :value="info.removeAnchorProposal" style="text-align:center"></md-input>
            </md-field>
            <md-field>
              <label for="">هش فایل پیشنهاد</label>
              <md-input :value="info.fileHash" style="text-align:center"></md-input>
            </md-field>
          </md-card-content>
      </md-card>
    </md-dialog> 
    <modal :width="'1200px'" :height="'auto'"   name="votters" >
      <div class="row" style="padding:1em;">
        <div class="col-sm-4">
          <h6>نمایندگان موافق با این پیشنهاد</h6>
          <table class="mytable">
            <tr>
              <th>آدرس نماینده</th>
              <th>میزبان متبوع</th>
            </tr>
            <tr  v-for="(_member,index) in agree_members" v-bind:key="index">
              <td>{{_member && _member.member}}</td>
              <td>{{_member && _member.anchor_name}}</td>
            </tr>
          </table>
        </div>
        <div class="col-sm-4">
          <h6>نمایندگان مخالف با این پیشنهاد</h6>
          <table class="mytable">
            <tr>
              <th>آدرس نماینده</th>
              <th>میزبان متبوع</th>
            </tr>
            <tr v-for="(_member,index) in opponent_members" v-bind:key="index">
              <td>{{_member && _member.member}} </td>
              <td>{{_member && _member.anchor_name}} </td>
            </tr>
          </table>
        </div>
        <div class="col-sm-4">
          <h6>نمایندگانی که هنوز به این پیشنهاد رای ندادند</h6>
          <table class="mytable">
            <tr>
              <th>آدرس نماینده</th>
              <th>میزبان متبوع</th>
            </tr>
            <tr v-for="(_member,index) in abstain_members" v-bind:key="index">
              <td>{{_member && _member.member}} </td>
              <td>{{_member && _member.anchor_name}} </td>
            </tr>
          </table>
        </div>
      </div>
    </modal>
    <div class="cntr">
      <div class="side-bar" v-bind:style="{display:this.displayWidth? 'block':'none'}">
        <img  src="../assets/menu.png"  alt="">
        <div class="list-itm list-itm-first" v-bind:class="{active:this.intendedTable==0}">
          <md-button @click="intendedTable=0" >فهرست میزبان ها</md-button>
        </div>
        <div class="list-itm" v-bind:class="{active:this.intendedTable==1}" >
          <md-button @click="intendedTable=1" >پیشنهاد های پذیرفته شده</md-button>
        </div>
        <div class="list-itm" v-bind:class="{active:this.intendedTable==2}" >
          <md-button @click="intendedTable=2" >پیشنهاد های مردود</md-button>
        </div>
        <div class="list-itm list-itm-last" v-bind:class="{active:this.intendedTable==3}" >
          <md-button @click="intendedTable=3" >پیشنهاد های در حال رای گیری</md-button>
        </div>
      </div>
      <div class="table-responsive cardo">
        <table class="table" v-if="intendedTable==0 || showAll" dir="rtl">
          <thead>
            <tr>
              <th colspan="5">
                <h5 class="text-center">فهرست میزبانان</h5>
              </th>
            </tr>
            <tr>
              <th scope="col">ردیف</th>
              <th scope="col">نشان</th>
              <th scope="col">نام میزبان</th>
              <th scope="col">وبگاه میزبان</th>
              <th scope="col"> نشانی اتریومی نمایندگان میزبان ها (توکن مانده)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in anchors">
              <td >{{ anchors.indexOf(item) }}</td>
              <td ><img :src="getLogo(item.name)" width="50px"></td>
              <td >{{ item.name }}</td>
              <td >{{ item.url }}</td>
              <td style="text-align:center">
                  <div  v-for="(member,index) of AnchorMembers(item.nameHash)" v-bind:key="index">{{`${ member.member}  (${balances[member.member]})`}}</div>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="table" v-if="intendedTable==1 || showAll" dir="rtl">
          <thead>
            <tr>
              <th colspan="9">
              <h5 class="text-center">پیشنهاد های پذیرفته شده</h5></th>
            </tr>
            <tr>
              <th scope="col">کد پیشنهاد</th>
              <th scope="col">عنوان پیشنهاد</th>
              <th scope="col">نشانی فایل پیشنهاد</th>
              <th scope="col">تاریخ آغاز رای گیری</th>
              <th scope="col">مهلت رای</th>
              <th scope="col">آرای موافق</th>
              <th scope="col">آرای مخالف</th>
              <th scope="col">رای دهی</th>
            </tr>
          </thead>
          <tbody>
              <tr v-for="item in this.approved_proposals">
                <td>{{ item.id }}</td>
                <td>
                  <md-button v-if="item.proposalType == 6" @click="()=>{returnProposalContent(item.proposalType,item.id)}">{{item.title }} </md-button>
                  <md-button v-else-if="item.proposalType == 7"   @click="()=>{returnProposalContent(item.proposalType,item.id)}">{{item.title + '(پیشنهاد xdr)'}} </md-button>
                  <md-button v-else @click="()=>{returnProposalContent(item.proposalType,item.id)}">{{proposalTitle(item.title)}} </md-button>        
                </td>
                <td>
                  <textarea v-if="item.proposalType == 7" readOnly rows="10" :value="item.url"> </textarea>
                  <div v-else>
                    {{item.url}} 
                  </div>
                </td>
                <td> {{ item.startDate  }} </td>
                <td> {{ item.endDate }} </td>
                <td class="votters" @click="ShowVotters(item.id)"> {{ item.up }} </td>
                <td class="votters" @click="ShowVotters(item.id)"> {{ item.down }} </td>
                <td>
                  <md-button class="md-raised md-primary" @click="RunProposal(item.id,item.proposalType)" >اجرا</md-button>                  
                </td>
              </tr>
          </tbody>
        </table>
        <table class="table" v-if="intendedTable==2 || showAll" dir="rtl">
          <thead>
            <tr>
              <th colspan="8">
              <h5 class="text-center">پیشنهاد های مردود</h5></th>
            </tr>
            <tr>
              <th scope="col">کد پیشنهاد</th>
              <th scope="col">عنوان پیشنهاد</th>
              <th scope="col">نشانی فایل پیشنهاد</th>
              <th scope="col">تاریخ آغاز رای گیری</th>
              <th scope="col">مهلت رای</th>
              <th scope="col">آرای موافق</th>
              <th scope="col">آرای مخالف</th>
            </tr>
          </thead>
          <tbody>
              <tr v-for="item in this.rejected_proposals">
                <td>{{ item.id }}</td>
                <td>
                  <md-button v-if="item.proposalType == 6" @click="()=>{returnProposalContent(item.proposalType,item.id)}">{{item.title }} </md-button>
                  <md-button v-else-if="item.proposalType == 7"   @click="()=>{returnProposalContent(item.proposalType,item.id)}">{{item.title + '(پیشنهاد xdr)'}} </md-button>
                  <md-button v-else @click="()=>{returnProposalContent(item.proposalType,item.id)}">{{proposalTitle(item.title)}} </md-button>        
                </td>
                <td>
                  <textarea v-if="item.proposalType == 7" readOnly rows="10" :value="item.url"> </textarea>
                  <div v-else>
                    {{item.url}} 
                  </div>
                </td>
                <td> {{ item.startDate  }} </td>
                <td> {{ item.endDate }} </td>
                <td class="votters" @click="ShowVotters(item.id)"> {{ item.up }} </td>
                <td class="votters" @click="ShowVotters(item.id)"> {{ item.down }} </td>
              </tr>
          </tbody>
        </table>
        <table class="table" v-if="intendedTable==3 || showAll" dir="rtl">
          <thead>
            <tr>
              <th colspan="9">
              <h5 class="text-center">پیشنهاد های در حال رای‌گیری</h5></th>
            </tr>
            <tr>
              <th>کد پیشنهاد</th>
              <th>عنوان پیشنهاد</th>
              <th>نشانی فایل پیشنهاد</th>
              <th>تاریخ آغاز رای گیری</th>
              <th>مهلت رای</th>
              <th>آرای موافق</th>
              <th>آرای مخالف</th>
              <th> رای دهی</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in this.ongoing_proposals"> 
              <td>{{ item.id }}</td>
              <td>
                <md-button v-if="item.proposalType == 6" @click="()=>{returnProposalContent(item.proposalType,item.id)}">{{item.title }} </md-button>
                <md-button v-else-if="item.proposalType == 7"   @click="()=>{returnProposalContent(item.proposalType,item.id)}">{{item.title + '(پیشنهاد xdr)'}} </md-button>
                <md-button v-else @click="()=>{returnProposalContent(item.proposalType,item.id)}">{{proposalTitle(item.title)}} </md-button>

              </td>
              <td>
                <textarea v-if="item.proposalType == 7" readOnly rows="10" :value="item.url"> </textarea>
                <div v-else>
                  {{item.url}} 
                </div>
              </td>
              <td>{{ item.startDate  }}</td>
              <td>{{ item.endDate }}</td>
              <td class="votters" @click="ShowVotters(item.id)">{{ item.up }}</td>
              <td class="votters" @click="ShowVotters(item.id)">{{ item.down }}</td>
              <td>
                <button class="btn-primary btn-sm" @click="Vote(item.proposalType,item.id,1)" >موافقت</button>
                <button class="btn-danger btn-sm"  @click="Vote(item.proposalType,item.id,-1)" >مخالفت</button>         
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
  import Vue from 'vue'
  import ContractUtils from '../contract'
  import async from 'async'
  import moment from 'moment-jalaali'
  import { mapGetters, mapActions } from 'vuex';
  export default {
    name: 'TableTemplate',
    computed:mapGetters(['account','contract']),
    mounted(){
      window.onresize=this.setSize;
      
      this.setSize();
      if(this.contract)
        {
          this.fetchData()
        }
      this.$store.subscribe((mutation,state)=>{
        switch (mutation.type) {
          case 'set_contract':
            if(state.contract){
              this.fetchData()
            }
            break;
        
          default:
            break;
        }
      });
      this.$store.subscribeAction((action,state)=>{
        switch (action.type) {
          case 'fetch_data':
            this.fetchData()
            
            break;
        
          default:
            break;
        }
      })
    },
    data: () => ({
      agree_members:[],
      opponent_members:[],
      abstain_members:[],

      members:[],
      balances:[],
      expired_proposals:[],
      ongoing_proposals:[],
      rejected_proposals:[],
      approved_proposals:[],

      proposals_count:0,
      anchors_count:0,
      proposals:[],
      anchors:[],
      signature:"",
      signedTransaction:false,

      addProposals:[],
      showAll:false,


      //for case 5
      _kuknos_proposal_id:"",
      _kuknos_proposal_type:"",
      _kuknos_proposal_vote:null,

      displayWidth:true,
      info:{},
      showInfo:false,
      intendedTable:0
    }),
    methods:{
      ...mapActions(['set_members']),
      ExecuteOrNot(endDate ){
          let hei = moment().format('jYYYY/jMM/jDD HH:mm');
         return (endDate < hei  ?'اجرا شده':'اجرا')

      },
      RunProposal(id,type){
        console.log(id,type)
        let contract = ContractUtils.getContract();
        switch (type) {
          case 0:
          case 1:
            contract.methods.runAddOrUpdateAnchorProposal(id,type)
              .send({from:this.account})
              .then(data=>{
              }).catch(err=>{
              })
            break;
          case 2:
            try {
              contract.methods.runRemoveAnchorProposal(id)
                .send({from:this.account})
                .then(data=>{
                }).catch(err=>{
              })
              
            } catch (error) {
              console.log(error)
            }

            break;
          case 4:
            contract.methods.runSetAccessTockenProposal(id)
              .send({from:this.account})
              .then(data=>{
              }).catch(err=>{
              })
            break;
        
          default:
            break;
        }
      },
      async balanceOf(address){
        let contract = ContractUtils.getContract();
        if(contract)
        {  
          let balance = await contract.methods
                      .balanceOf(address)
                      .call()
          this.balances[address] = balance.toString();
        }
      },
      returnProposalContent(type,proposal_id){
        this.info = {};
        let contract = ContractUtils.getContract();
        contract
          .methods
          .getProposal(proposal_id)
          .call()
          .then(data=>{
              this.info.fileHash = data.hashCode
              switch (type) {
                case 0:
                  contract.methods
                    .addOrUpdateAnchorProposals(proposal_id)
                    .call()
                    .then(data=>{
                      this.info.newProposal  =  data.name;
                      contract.methods
                        .getAddOrUpdateAnchorProposalMembers(proposal_id)
                        .call()
                        .then(data=>{
                          this.info.newMembers = data;
                          this.showInfo = true;
                          //alert(this.info.newProposal)
                          //this.$modal.show('info')
                        })
                    })

                  break;
                case 1:
                  contract.methods
                    .addOrUpdateAnchorProposals(proposal_id)
                    .call()
                    .then(data=>{
                      this.info.updateAnchorProposals = data
                      contract.methods
                        .getAddOrUpdateAnchorProposalMembers(proposal_id)
                        .call()
                        .then(data=>{
                          this.info.updatedMembers = data;
                          this.showInfo = true;
                          //alert(this.info.newProposal)
                          //this.$modal.show('info')
                        })
                    })
                  break;
                case 2:
                  contract.methods
                    .removeAnchorProposal(proposal_id)
                    .call()
                    .then(data=>{
                      this.info.removeAnchorProposal = data.name
                      this.showInfo = true;
                    })
                  break;
                case 3:
                  break;
              
                default:
                  break;
              }
          })
        
      },
      setSize(){
        var width = window.innerWidth
                      || document.documentElement.clientWidth
                      || document.body.clientWidth;
        if(width < 1080){
          this.displayWidth = false;
          this.showAll = true;
        }
        else{
          this.displayWidth = true;
          this.showAll = false;
        }
      },
      fetchData(){
        this.proposals=[];
        this.$Progress.start()
        let contract = ContractUtils.getContract();
        
              contract && contract.methods
                  .getProposalsCount()
                  .call()
                  .then(data=>{
                      this.proposals_count = parseInt(data.toString());
                      async.each(Array.from(Array(this.proposals_count).keys()),(proposal_id,next)=>{
                          contract.methods
                            .getProposal(proposal_id)
                            .call({from:this.account})
                            .then(data=>{
                              let proposal =  {
                                  id:proposal_id,
                                  title:data.title,
                                  proposalType:parseInt(data.proposalType.toString()),
                                  startDate:moment(data.startDate.toString()*1000).format("jYYYY/jMM/jDD HH:mm"),
                                  endDate:moment(data.endDate.toString()*1000).format('jYYYY/jMM/jDD HH:mm'),
                                  registerDate:moment(data.register).format('jYYYY/jMM/jDD HH:mm'),
                                  url:data.url,
                                  //up:parseInt(data.up.toString()),
                                  //down:parseInt(data.down.toString()),
                                  author:data.author
                                }
                              contract.methods.getProposalStatus(proposal_id)
                                .call({from:this.account})
                                .then(data1=>{
                                  if(data1)
                                  {
                                    proposal.up = parseInt(data1.up.toString())
                                    proposal.down = parseInt(data1.down.toString())
                                    proposal.isApproved = data1.isSucceed
                                  }
                                  this.proposals.push(proposal);
                                  next()
                                }).catch(err=>{
                                })
                            }).catch(err=>{
                            })
                      },(err)=>{
                        this.getSegregateProposals();
                      })
                        
                    }
                  ).catch(err=>{
                  })
                contract.methods
                  .getAnchorsCount()
                  .call()
                  .then(data=>{
                    this.anchors=[];
                    this.anchors_count = parseInt(data.toString())
                    async.each(Array.from(Array(this.anchors_count).keys()),(anchor_id,next1)=>{
                        contract.methods
                          .anchors(anchor_id)
                          .call({from:this.account})
                          .then(data=>{
                            let anchor= {
                              name:data.name,
                              url:data.url,
                              nameHash:data.nameHash,  
                              members:[]
                            };
                            this.anchors.push(anchor);
                            next1();
                          }).catch(err=>{
                          })
                    },(err)=>{
                        this.members = [];
                        this.anchors
                          .forEach((anchor)=>{
                            // let member={
                            //   anchor:nameHash,
                            //   members:[]
                            // };
                            //member.anchor = nameHash;
                            async.times(2, (id,next2)=>{
                              contract.methods 
                                .anchorMembers(anchor.nameHash,id)
                                .call()
                                .then(async (data)=>{
                                  await this.balanceOf(data)
                                  this.members.push({anchor:anchor.nameHash,member:data})
                                  next2()
                                }).catch(err=>{
                                })
                            },(err,final)=>{
                              this.set_members(this.members);
                              this.$Progress.finish()
                            }
                          
                        )
                    })
                  }
                  )}).catch(err=>{
                  })
                  
      },
      getLogo(anchor_name){
        return 'https://kuknos.org/dao_logo/'+anchor_name+'.png'
      },
      getSegregateProposals(){
        let now = moment().format("jYYYY/jMM/jDD HH:mm");
        this.ongoing_proposals = this.proposals.filter(proposal=>(proposal.startDate < now && proposal.endDate > now))
        let expired_proposals = this.proposals.filter(proposal=>( proposal.endDate < now));
        this.approved_proposals = expired_proposals.filter(proposal=>proposal.isApproved)
        this.rejected_proposals = expired_proposals.filter(proposal=>!proposal.isApproved)

      },
      AnchorMembers(nameHash){
        return this.members.filter(({anchor})=>anchor==nameHash)
      },
      proposalTitle(proposalTitle){
        if(!this.account)
          {
            alert('error')
          }
        switch (proposalTitle) {
          case 'add anchor':
            return `افزودن میزبان`
            break;
        
          case 'remove anchor':
            return 'حذف میزبان'
            break;
        
          case 'set access tocken':
            return 'مقدار دهی توکن به اعضا'
            break;
          case 'update anchor':
            return 'تغییر نماینده ی میزبان'
            break;
        
          default:
            break;
        }
      },
      Vote(proposalType,id,vote){
        if(proposalType ==7 && !this.signedTransaction && vote==1)
        {
          this._kuknos_proposal_id = id;
          this._kuknos_proposal_type= proposalType;
          this._kuknos_proposal_vote = vote;

          this.$modal.show('signature');
          return;
        }
        else if(this.signedTransaction && proposalType==7){
          this.$modal.hide('signature')
        }
        let contract = ContractUtils.getContract();
        contract
        .methods
        .voteForProposal(id,vote,this.signature)
        .send({from:this.account})
        .then(data=>{
        })
      },
      ShowVotters(proposal_id){
        let contract = ContractUtils.getContract();
        this.agree_members = [];
        this.opponent_members=[];
        this.abstain_members=[];
        async.map(this.members,({anchor,member},cb)=>{
          contract.methods
            .votesReceived(proposal_id,member)
            .call()
            .then((data)=>{
              let vote = parseInt(data.vote);
              let {name} =this.anchors.find(anch=>anch.nameHash==anchor)
              console.log(`anchor address--${anchor} anchor name--${name} member--${member} vote--${vote} data--${data}`)

              switch (vote) {
                case 1:
                  this.agree_members.push({member,anchor_name:name})
                  break;
                case 0:
                  this.abstain_members.push({member,anchor_name:name});
                  break;
                case -1:
                  this.opponent_members.push({member,anchor_name:name});
                  break;
                default:
                  break;
              }
              cb()
            })
            .catch(err=>{
              console.log('err',err)
            })
        },(err,result)=>{
          this.$modal.show('votters')
        })
      }
    }
  }
</script>
<style scoped>
  h1{
    color: #008080;
  }
  .cardo{
    padding: 2em;
    margin-right: 0;
    -webkit-box-shadow: -18px 18px 32px 0px rgba(0,0,0,0.75);
    -moz-box-shadow: -18px 18px 32px 0px rgba(0,0,0,0.75);
    box-shadow: -18px 18px 32px 0px rgba(0,0,0,0.75);
    -webkit-border-top-left-radius: 20px;
    -webkit-border-bottom-left-radius: 20px;
    -moz-border-radius-topleft: 20px;
    -moz-border-radius-bottomleft: 20px;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    flex: 5
  }
  .mytable {
      border-collapse: collapse;
  }
  .mytable th,.mytable td {
      padding: 5px;
      border: 1px solid black;
  }
  .votters{
    cursor: pointer;
  }
  .mytable th {
    text-align: left;
  }
  th,td{
    font-size: 12px;
    text-align: center;
  }
  .side-bar{
    background: rgb(5,136,255);
    background: linear-gradient(0deg, #29539d 0%, #047fba 94%);
    -webkit-border-top-right-radius: 20px;
    -webkit-border-bottom-right-radius: 20px;
    -moz-border-radius-topright: 20px;
    -moz-border-radius-bottomright: 20px;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    flex:1;
  }
  .list-itm{
    margin: 0;
    color: white;
    border-bottom: 1px solid white;
    text-align: center;
    width: 100%;
  }
  .list-itm-first{
    border-top-right-radius: 20px
  }
  .list-itm-last{
    border-bottom-right-radius: 20px
  }
  .list-itm > button{
    color: white
  }
  .active{
    background-color: #bae8ff;
  }
  img{
    margin: 2em
  }
  .cntr{
    margin-top: 50px;
    display:flex ;
    flex-direction:row-reverse;
    margin-left: 50%;
    width: 90%;
    transform: translateX(-50%)
  }
  h6,h5{
    text-align: center;
    font-weight: 700;
  }
</style>